export const IS_AGENT_AUTHENTICATED = "IS_AGENT_AUTHENTICATED";
export const SET_AGENT = "SET_AGENT";
export const SET_AGENTS = "SET_AGENTS";
export const ADD_AGENT = "ADD_AGENT";
export const SET_ALL_AGENTS = "SET_ALL_AGENTS";
export const SET_ALL_AGENTS_MAP = "SET_ALL_AGENTS_MAP";
export const UPDATE_AGENT = "UPDATE_AGENT";
export const SET_AGENT_SELECTED = "SET_AGENT_SELECTED";
export const SHOW_AGENT_DETAIL = "SHOW_AGENT_DETAIL";
export const SET_MENU_ITEMS = "SET_MENU_ITEMS";
export const SET_AGENT_INTEGRATIONS = "SET_AGENT_INTEGRATIONS";
